module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_G170462.4d340e6b.png";